import React from 'react';
import HeadWrapper from 'app/shared/components/HeadWrapper';
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';

const DEFAULT_PAGE_TITLE = 'Market';

// eslint-disable-next-line arrow-body-style
const MarketPage = () => {
    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <div>
                <HeadWrapper title={DEFAULT_PAGE_TITLE} />
                To Do
            </div>
        </AuthCheckWrapper>
    );
};

export default MarketPage;
